var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',[_c('carousel',{staticClass:"primary-slides",attrs:{"items":1,"nav":false,"autoplay":true,"dots":true,"autoplayTimeout":8000}},_vm._l((_vm.items),function(ref,keyItem){
var img_desktop = ref.img_desktop;
var img_mobile = ref.img_mobile;
var title = ref.title;
var link = ref.link;
var target = ref.target;
return _c('div',{key:keyItem,staticClass:"item"},[(link)?_c('a',{attrs:{"href":link,"target":target ? '_blank' : ''}},[_c('img',{staticClass:"img-slide",attrs:{"src":_vm.files + (_vm.xs ? img_mobile : img_desktop),"alt":title}})]):_c('img',{staticClass:"img-slide",attrs:{"src":_vm.files + (_vm.xs ? img_mobile : img_desktop),"alt":title}})])}),0)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }